import React from "react";
import { useTranslation } from "react-i18next";
import { HiOutlineExternalLink } from "react-icons/hi";
import { twMerge } from "tailwind-merge";

export const profilePath = (userId: string) =>
  `/control-panel/users/${encodeURIComponent(userId)}`;

interface ProfileLinkProps {
  href: string;
  name: string;
  /** Only the icon on phones, where the row has no room for the words. */
  compactOnPhone?: boolean;
}

/** A person's profile in a new tab, so that what is being edited here stays as it is. */
const ProfileLink: React.FC<ProfileLinkProps> = ({
  href,
  name,
  compactOnPhone = false,
}) => {
  const { t } = useTranslation();
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t("agenda.openProfileOf", { name }) as string}
      className={twMerge(
        "inline-flex shrink-0 items-center gap-1 rounded-md text-sm text-blue-600 hover:text-blue-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500",
        compactOnPhone && "p-1 sm:p-0"
      )}
    >
      <span className={compactOnPhone ? "hidden sm:inline" : undefined}>
        {t("agenda.openProfile")}
      </span>
      <HiOutlineExternalLink
        size={compactOnPhone ? 16 : 14}
        aria-hidden="true"
      />
    </a>
  );
};

export default ProfileLink;
